import OappDocsChat from './OappDocsChat'

export default OappDocsChat
